<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-center">
  <span class="title-header">{{ 'reports.data-dictionary.title' | translate | titlecase }}</span>
</div>
<div class="mb-10 w-50 mct-grid data-dict-grid">
  <div>
    <p-select name="timeZone" placeholder="{{ 'common.select' | translate }}" [options]="allTables"
      [(ngModel)]="selectedTable" styleClass="w-100" [style]="{ 'min-width': '380px', height: '36px' }"></p-select>
  </div>
  <div class="mct-flex mct-col mct-justify-center mct-items-end">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="addTableToList()">
      {{ 'common.add' | translate | uppercase }}
    </button>
  </div>
  <div class="w-100 mt-15 mct-col-1-span-2-gt-sm atlas-autocomplete">
    <p-autocomplete
      [(ngModel)]="selectedTables"
      [inputStyle]="{ width: '100%' }"
      [suggestions]="tableSearchResult"
      (completeMethod)="searchTables($event)"
      [multiple]="true"
      [forceSelection]="true"
      appendTo="body"
      (onSelect)="search()"
    >
    </p-autocomplete>
  </div>
</div>
<hr class="mv-27" />
<div>
  <p-table [showGridlines]="true" [value]="tableResults" [tableStyle]="{ width: 'max-content' }" rowGroupMode="subheader" groupRowsBy="TableName">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="TableName" style="min-width: 380px; max-width: 600px">
          {{ 'reports.data-dictionary.grid.table-name' | translate | titlecase }} <p-sortIcon
            field="TableName"></p-sortIcon>
        </th>
        <th pSortableColumn="FieldName" style="min-width: 460px; max-width: 600px">
          {{ 'reports.data-dictionary.grid.field-name' | translate | titlecase }} <p-sortIcon
            field="FieldName"></p-sortIcon>
        </th>
        <th pSortableColumn="FieldType" style="max-width: 600px">
          {{ 'reports.data-dictionary.grid.field-type' | translate | titlecase }} <p-sortIcon
            field="FieldType"></p-sortIcon>
        </th>
        <th pSortableColumn="FieldLimit" style="max-width: 600px">
          {{ 'reports.data-dictionary.grid.field-limit' | translate | titlecase }} <p-sortIcon
            field="FieldLimit"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-result>
      <tr>
        <td>{{result.TableName}}</td>
        <td>{{result.FieldName}}</td>
        <td>{{result.FieldType}}</td>
        <td>{{result.FieldLimit}}</td>
      </tr>
    </ng-template>
  </p-table>
<p-progressSpinner *ngIf="isSearching"></p-progressSpinner>
</div>